import React from 'react';
import { Upload } from 'antd';
import { CardButton } from '../Card';
import { ReactComponent as AddFileIcon } from '../../resource/AddFileIcon.svg';

const UploadButton = ({
  buttonClassName,
  buttonText = 'Прикрепить файл',
  buttonComponent,
  fullWidth = true,
  ...props
}) => {
  return (
    <Upload {...props}>
      {buttonComponent ? (
        buttonComponent
      ) : (
        <CardButton
          disabled={props.disabled}
          className={buttonClassName}
          block={fullWidth}
          text={props.disabled ? 'Чтобы добавить документы измените статус счетчика' : buttonText}
          icon={<AddFileIcon />}
        />
      )}
    </Upload>
  );
};

export default UploadButton;
